
































import {
  Vue, Prop, Component, Watch,
} from 'vue-property-decorator';

@Component
export default class DatePicker extends Vue {
  private menu: boolean = false;

  @Watch('clearDatePicker')
  onClearDatePickerChanged(newVal: boolean) {
    if (newVal) {
      this.updateDate('');
    }
  }

  @Prop({
    type: String,
    default: '',
  })
  private date!: string;

  @Prop({
    type: Boolean,
    default: false,
  })
  private useInnerValue!: boolean;

  @Prop({
    type: String,
    default: '',
  })
  private label!: string;

  @Prop({
    type: Boolean,
    default: false,
  })
  private clearable!: boolean;

  @Prop({
    type: Boolean,
    default: false,
  })
  private clearDatePicker!: boolean;

  private innerValue: string = '';

  private get language(): string {
    if (this.$i18n.locale === 'pt') {
      return 'pt-br';
    }
    return 'en-us';
  }

  private get value(): string {
    if (this.useInnerValue) return this.innerValue;
    return this.date;
  }

  created() {
    if (this.date) {
      this.updateDate(this.date);
    }
  }

  private updateDate(date: string): void {
    this.$emit('updateDate', date);
    this.menu = false;
    if (this.useInnerValue) {
      this.innerValue = date;
    }
  }
}
